const CACHE_KEY = "accountCompanyIdCache";
const DEFAULT_TTL_MS = 24 * 60 * 60 * 1000;

function safeParse(raw) {
  if (!raw) return {};
  try {
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
}

export function readCachedAccountCompanyId(accountId) {
  if (!accountId && accountId !== 0) return null;
  const raw = localStorage.getItem(CACHE_KEY);
  const store = safeParse(raw);
  const entry = store[String(accountId)];
  if (!entry || entry.companyId == null) return null;

  const now = Date.now();
  const savedAt = Number(entry.savedAt || 0);
  if (savedAt && now > savedAt + DEFAULT_TTL_MS) return null;

  return entry.companyId;
}

export function writeCachedAccountCompanyId(accountId, companyId) {
  if (!accountId && accountId !== 0) return;
  if (!companyId && companyId !== 0) return;

  const raw = localStorage.getItem(CACHE_KEY);
  const store = safeParse(raw);
  store[String(accountId)] = {
    companyId,
    savedAt: Date.now(),
  };
  localStorage.setItem(CACHE_KEY, JSON.stringify(store));
}
